var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScheduledCl(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 69,
    height: 84,
    viewBox: "0 0 69 84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#4E443D",
    strokeWidth: 6,
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M10.7470588,77.6803476 L52.2529412,77.6803476 C57.9833471,77.6803476 62.6294118,73.0644521 62.6294118,67.3712567 L62.6294118,15.8258021 C62.6294118,10.1326067 57.9833471,5.51671123 52.2529412,5.51671123 L10.7470588,5.51671123 C5.01665294,5.51671123 0.370588235,10.1326067 0.370588235,15.8258021 L0.370588235,67.3712567 C0.370588235,73.0644521 5.01665294,77.6803476 10.7470588,77.6803476 Z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17.232,
    x2: 45.768,
    y1: 0.362,
    y2: 0.362
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16 31)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M25.2873563 19.6749345L25.2873563.19036096M5.64597701.19036096L5.64597701 19.6749345M30.743295 14.2625529L30.743295 5.60274249M.190038314 5.60274249L.190038314 14.2625529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.97203065,9.96632386 L22.9613027,9.96632386 L7.97203065,9.96632386 Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduledCl);
export default __webpack_public_path__ + "static/media/scheduled-cl.e5952f598512f0a9d13f65e79931e43e.svg";
export { ForwardRef as ReactComponent };